import {useTranslation} from 'react-i18next';

import {SxProps, Typography} from '@mui/material';

import {Editable} from './Editable';
import * as Types from '../../types';

interface Props {
  sx?: SxProps;
  onEdit?: (formType: Types.ProfileFormType) => void;
  dreamJobDescription: string | null;
}

export const DreamJob = ({sx, onEdit, dreamJobDescription}: Props) => {
  const {t} = useTranslation();
  return (
    <Editable
      sx={{
        ...sx,
      }}
      onEdit={() => onEdit?.('dream-job')}
      testid='dream-job'
    >
      <Typography variant='h2'>{t('applicantProfile.dreamJob.title')}</Typography>
      <Typography
        sx={{
          wordBreak: 'break-word',
        }}
        variant='body1'
        dangerouslySetInnerHTML={{__html: dreamJobDescription || ''}}
      />
    </Editable>
  );
};
